var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base",class:[ _vm.isMine ? 'right' : 'left']},[_c('div',{staticClass:"name text-ellipsis"},[_vm._v(_vm._s(_vm.from))]),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.date))])])
}
var staticRenderFns = []

export { render, staticRenderFns }